export const EOrderStatus = {
  Draft: "draft",
  Pending: "pending",
  Processing: "processing",
  Processed: "processed",
  Settled: "settled",
  Failed: "failed",
  Canceled: "canceled",
} as const;
export type TOrderStatus = (typeof EOrderStatus)[keyof typeof EOrderStatus];
